import { render } from "./rulesAbout.vue?vue&type=template&id=687543a0&scoped=true"
import script from "./rulesAbout.vue?vue&type=script&lang=js"
export * from "./rulesAbout.vue?vue&type=script&lang=js"

import "./rulesAbout.vue?vue&type=style&index=0&id=687543a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687543a0"]])

export default __exports__